import axiosInstance from "../variables/api/axiosInstance";
import { LOGGED_USER } from "../variables/constants";

const MAX_PAYLOAD_SIZE = 50000;

const safeStringify = (value) => {
  try {
    return JSON.stringify(value);
  } catch (e) {
    return null;
  }
};

const sanitizeSessionStorage = () => {
  if (typeof sessionStorage === "undefined") return {};
  // On limite à un petit nombre de clés utiles pour réduire la taille
  const allowList = new Set(["currentCompagnie"]);

  const snapshot = {};
  allowList.forEach((key) => {
    try {
      const value = sessionStorage.getItem(key);
      if (value !== null && value !== undefined) {
        snapshot[key] = value;
      }
    } catch (e) {
      // ignore storage read errors
    }
  });
  return snapshot;
};

const buildPayload = (data = {}) => {
  const base = {
    userId: LOGGED_USER?.userName || LOGGED_USER?.username,
    version: 1,
    clientInfo: {
      userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "",
      lang: typeof navigator !== "undefined" ? navigator.language : "",
    },
    savedAt: new Date().toISOString(),
    session: sanitizeSessionStorage(),
    ...data,
  };

  const raw = safeStringify(base);
  if (!raw) {
    throw new Error("Impossible de sérialiser l'état de reprise.");
  }
  if (raw.length > MAX_PAYLOAD_SIZE) {
    // Tentative sans snapshot session pour réduire la taille
    const slim = { ...base, session: {} };
    const slimRaw = safeStringify(slim);
    if (slimRaw && slimRaw.length <= MAX_PAYLOAD_SIZE) {
      return slim;
    }
    throw new Error("État à sauvegarder trop volumineux (>50k).");
  }
  return base;
};

const fetchLatest = async () => {
  try {
    const res = await axiosInstance.get("/api/user-session/latest");
    if (res?.status === 204) return null;
    return res?.data || null;
  } catch (e) {
    if (e?.response?.status === 404) return null;
    console.warn("ResumeService: fetchLatest failed", e);
    return null;
  }
};

const save = async (data = {}) => {
  try {
    const payload = buildPayload(data);
    await axiosInstance.post("/api/user-session", payload);
  } catch (e) {
    // On garde silencieux si payload trop volumineux ou endpoint indispo
    if (e?.message?.includes("trop volumineux") || e?.response?.status === 404) {
      return;
    }
    console.warn("ResumeService: save skipped", e?.message || e);
  }
};

const clear = async () => {
  try {
    await axiosInstance.delete("/api/user-session");
  } catch (e) {
    console.warn("ResumeService: clear failed", e);
  }
};

export default {
  fetchLatest,
  save,
  clear,
};
export { fetchLatest, save, clear, buildPayload };
